import parse from "html-react-parser";
import { useEffect, useState } from "react";

const ButtonBlockRender = ({ text, buttonText, buttonLink, targetBlank, position, buttonPosition = false }: { text: string, buttonText: string, buttonLink: string, targetBlank: boolean, position: 'left' | 'center' | 'right', buttonPosition: boolean }) => {
    const [resolvedPositionClassName, setResolvedPositionClassName] = useState<string>('');
    console.log(buttonPosition)
    useEffect(() => {
        switch(position){
            case 'left':
                setResolvedPositionClassName('mr-auto')
                break;
            case 'center':
                setResolvedPositionClassName('mx-auto')
                break;
            case 'right':
                setResolvedPositionClassName('ml-auto')
                break;
        }
    }, [position])

    return (
        <section className="mb-12 flex flex-col">
            <div className={`general-content-text-wrapper text-arcticMist ${buttonPosition ? 'order-2' : 'order-1'}`}>
                {text && parse(text)}
            </div>
            <div className={`general-content-text-wrapper ${buttonPosition ? 'order-1' : 'order-2'}`}>
                <a href={buttonLink} className={`block max-w-max main-btn ${resolvedPositionClassName}`} target={targetBlank ? '_blank' : ''}>
                    {buttonText}
                </a>
            </div>
        </section>
    )
}

export default ButtonBlockRender;